import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fcbf9ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "top-anchor",
  style: {"position":"absolute","top":"-100px","left":"0"}
}, null, -1))
const _hoisted_2 = { class: "spin" }
const _hoisted_3 = { id: "section1-div" }
const _hoisted_4 = {
  class: "ion-text-center",
  style: {"font-size":"0"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ion-text-center ion-padding-bottom" }, [
  /*#__PURE__*/_createElementVNode("b", null, "參加遊戲，請填妥以下簡單表格")
], -1))
const _hoisted_7 = { class: "ion-margin-top ion-text-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "參加遊戲", -1))
const _hoisted_9 = { ref: "recaptchaDiv" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "grecaptcha-div" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { id: "section2-div" }
const _hoisted_16 = {
  class: "ion-padding",
  id: "section3-div"
}
const _hoisted_17 = { class: "ion-text-center" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timer ion-text-center" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("請於 "),
    /*#__PURE__*/_createElementVNode("b", {
      class: "timer__countdown",
      style: {"font-size":"1.5em"}
    }, "15:00"),
    /*#__PURE__*/_createTextVNode(" 內完成下單"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("否則閣下將失去優惠")
  ])
], -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "優惠療程：", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "體驗價：", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "留位費（完成療程後會退回）：", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "交易手續費：", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "總計：", -1))
const _hoisted_26 = { class: "ion-margin-top ion-text-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "預約療程", -1))
const _hoisted_28 = { id: "paypal-button-container" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "預約療程", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "預約療程", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _withDirectives(_createElementVNode("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, { color: "primary" })
              ], 512), [
                [_vShow, _ctx.loadingData]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _withDirectives(_createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: _ctx.getProxyImgLink(_ctx.currBrand.bannerLink) || require('@/assets/banner.jpeg')
                    }, null, 8, _hoisted_5)
                  ]),
                  _createVNode(_component_ion_card, { style: {"margin-top":"-5px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _createElementVNode("form", {
                            onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submitApplication()), ["prevent"]))
                          }, [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { position: "floating" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("您的名字*")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  ref: "nameInput",
                                  type: "text",
                                  modelValue: _ctx.application.name,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.application.name) = $event)),
                                  enterkeyhint: "next",
                                  onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.focusInputField(_ctx.phoneInput)), ["enter"])),
                                  required: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { position: "floating" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("香港手提電話號碼*")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  ref: "phoneInput",
                                  inputmode: "numeric",
                                  placeholder: "8位數字",
                                  modelValue: _ctx.application.phone,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.application.phone) = $event)),
                                  minlength: "8",
                                  maxlength: "8",
                                  enterkeyhint: "next",
                                  onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.focusInputField(_ctx.emailInput)), ["enter"])),
                                  required: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { position: "floating" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("電郵地址*")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  ref: "emailInput",
                                  inputmode: "email",
                                  type: "email",
                                  modelValue: _ctx.application.email,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.application.email) = $event)),
                                  enterkeyhint: "next",
                                  onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.submitBtn?.$el.click()), ["enter"])),
                                  required: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_ion_button, {
                                ref: "submitBtn",
                                type: "submit",
                                size: "large",
                                shape: "round",
                                disabled: _ctx.application.submittingForm
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_8,
                                  _createElementVNode("div", _hoisted_9, _hoisted_11, 512)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ])
                          ], 32)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.currBrand.tncImgLink)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.getProxyImgLink(_ctx.currBrand.tncImgLink),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openImageModal(_ctx.currBrand.tncImgLink)))
                      }, null, 8, _hoisted_12))
                    : (_ctx.currBrandId == 'elemental-medical-wishpro')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: require('@/assets/wishpro/tnc.png'),
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openImageModal(require('@/assets/wishpro/tnc.png'))))
                        }, null, 8, _hoisted_13))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          src: require('@/assets/tnc.jpeg'),
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openImageModal(require('@/assets/tnc.jpeg'))))
                        }, null, 8, _hoisted_14))
                ], 512), [
                  [_vShow, _ctx.section == 1]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    id: "lottie-animation",
                    style: _normalizeStyle({ 'background': (_ctx.currBrandId == 'elemental-medical-wishpro' ? `url('${require('@/assets/wishpro/bg_lucky_draw.png')}') no-repeat`
                                                                                    : `url('${require('@/assets/bg_lucky_draw.jpeg')}') no-repeat`) })
                  }, null, 4)
                ], 512), [
                  [_vShow, _ctx.section == 2]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    (_ctx.orderObj.giftImageLink)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"100%"},
                          src: _ctx.getProxyImgLink(_ctx.orderObj.giftImageLink)
                        }, null, 8, _hoisted_18))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_ion_card, { class: "ion-no-margin" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _createElementVNode("form", {
                            id: "order-form",
                            onSubmit: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.submitOrder()), ["prevent"]))
                          }, [
                            _createVNode(_component_ion_list, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_list_header, { color: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 聯絡資料 ")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { position: "floating" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("您的名字*")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      type: "text",
                                      modelValue: _ctx.orderObj.customerName,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.orderObj.customerName) = $event)),
                                      required: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { position: "floating" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("香港手提電話號碼*")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      inputmode: "numeric",
                                      placeholder: "8位數字",
                                      modelValue: _ctx.orderObj.contactPhone,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.orderObj.contactPhone) = $event)),
                                      maxlength: "8",
                                      required: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { position: "floating" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("電郵地址*")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      inputmode: "email",
                                      type: "email",
                                      modelValue: _ctx.orderObj.customerEmail,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.orderObj.customerEmail) = $event)),
                                      required: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_list, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_list_header, { color: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 請選擇療程日期、時間 ")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_item, {
                                  id: "open-date-input",
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { position: "floating" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("療程日期*")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      type: "text",
                                      modelValue: _ctx.orderObj.deliveryDate,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.orderObj.deliveryDate) = $event)),
                                      required: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_modal, {
                                  ref: "dateInputModal",
                                  "keep-contents-mounted": true,
                                  trigger: "open-date-input",
                                  "show-backdrop": true,
                                  style: {"--width":"fit-content","--height":"fit-content"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_datetime, {
                                      mode: "ios",
                                      modelValue: _ctx.orderObj.deliveryDate,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.orderObj.deliveryDate) = $event)),
                                      presentation: "date",
                                      "display-format": "DD MMM YYYY (DDD)",
                                      "picker-format": "YYYY MMM DD",
                                      min: _ctx.minDate,
                                      max: _ctx.maxYear,
                                      onIonChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSelectBookingDate())),
                                      "is-date-enabled": _ctx.isBookingDateEnabled
                                    }, null, 8, ["modelValue", "min", "max", "is-date-enabled"])
                                  ]),
                                  _: 1
                                }, 512),
                                _withDirectives(_createElementVNode("div", null, [
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { position: "stacked" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("療程地點*")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_select, {
                                        interface: "popover",
                                        modelValue: _ctx.orderObj.location,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.orderObj.location) = $event)),
                                        onIonChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateApplication('selectedBookingLocation', _ctx.orderObj.location)))
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationOptions, (location) => {
                                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                                              key: location,
                                              value: location
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(location), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { position: "floating" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("療程時間*")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_select, {
                                        interface: "popover",
                                        modelValue: _ctx.orderObj.deliveryTime,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.orderObj.deliveryTime) = $event)),
                                        onIonChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updateApplication('selectedBookingTime', _ctx.orderObj.deliveryTime)))
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTimeSlots, (timeSlot) => {
                                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                                              key: timeSlot,
                                              value: timeSlot
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(timeSlot), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ], 512), [
                                  [_vShow, _ctx.orderObj.deliveryDate]
                                ])
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createElementVNode("div", null, [
                              _createVNode(_component_ion_list, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_radio_group, {
                                    modelValue: _ctx.orderObj.paymentMethod,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.orderObj.paymentMethod) = $event)),
                                    onIonChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.updateApplication('selectedPaymentMethod', _ctx.orderObj.paymentMethod)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_list_header, { color: "primary" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" 請選擇付款方式 ")
                                        ]),
                                        _: 1
                                      }),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (method) => {
                                        return (_openBlock(), _createBlock(_component_ion_item, {
                                          key: method.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_radio, {
                                              slot: "start",
                                              value: method.value,
                                              onClick: ($event: any) => (_ctx.orderObj.transactionFee = method.transactionFee || 0)
                                            }, null, 8, ["value", "onClick"]),
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("h3", null, [
                                                  _createElementVNode("b", null, _toDisplayString(method.label), 1)
                                                ]),
                                                (method.transactionFee)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                                      _createElementVNode("small", null, "需收手續費HK$" + _toDisplayString(method.transactionFee), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_icon, {
                                              icon: method.icon,
                                              slot: "end"
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_21
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, [
                                        _createElementVNode("b", null, _toDisplayString(_ctx.orderObj.giftName), 1)
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_22
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, "HK$" + _toDisplayString(_ctx.orderObj.giftPrice), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _withDirectives(_createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_23
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, "HK$" + _toDisplayString(_ctx.orderObj.giftDeposit), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, _ctx.orderObj.giftDeposit > 0]
                              ]),
                              _withDirectives(_createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_24
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, "HK$" + _toDisplayString(_ctx.orderObj.transactionFee), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, _ctx.orderObj.transactionFee > 0]
                              ]),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_25
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h1", null, "HK$" + _toDisplayString(_ctx.getOrderTotalPrice()), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _withDirectives(_createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_ion_button, {
                                  type: "submit",
                                  size: "large",
                                  shape: "round",
                                  disabled: _ctx.orderObj.submittingOrder,
                                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateApplication('clickedOrderBtn', true)))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_27
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ], 512), [
                                [_vShow, _ctx.orderObj.paymentMethod != 'paypal']
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_28, null, 512), [
                                [_vShow, _ctx.orderObj.paymentMethod == 'paypal']
                              ])
                            ], 512), [
                              [_vShow, _ctx.orderObj.deliveryTime]
                            ])
                          ], 32)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _ctx.section == 3]
                ])
              ], 512), [
                [_vShow, !_ctx.loadingData]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_modal, {
            id: "gift-modal",
            class: "ion-text-center",
            "is-open": _ctx.isGiftModalOpened,
            "show-backdrop": false,
            backdropDismiss: false
          }, {
            default: _withCtx(() => [
              (_ctx.orderObj.giftImageLink)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.getProxyImgLink(_ctx.orderObj.giftImageLink)
                  }, null, 8, _hoisted_29))
                : _createCommentVNode("", true),
              _hoisted_30,
              (['elemental-medical-wishpro', 'elemental'].includes(_ctx.currBrandId.toString()))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onCompleteLuckyDraw()))
                  }, [
                    _createVNode(_component_ion_button, {
                      size: "large",
                      shape: "round",
                      style: {"margin-top":"-20px","visibility":"hidden","height":"80px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createBlock(_component_ion_button, {
                    key: 2,
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onCompleteLuckyDraw())),
                    size: "large",
                    shape: "round",
                    style: {"margin-top":"-20px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }, 8, ["is-open"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}